export const GET_CAR = 'GET_CAR';
export const RESET_CAR = 'RESET_CAR';
